export const BenefitType = {
    Dental: 'Dental',
    Medical: 'Medical',
};
//# sourceMappingURL=benefit.js.map